import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
} from '@mui/material';
import nodata from '../../assets/nodata.jpg';
const ReusableRoleTable = ({
  roles = [],
  permissionsList = [],
  handleView,
  handleEdit,
  handleDeleteClick,
}) => {
  return roles.length > 0 ? (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Role ID</TableCell>
            <TableCell>Role Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.map((role, roleIndex) => {
            const rolePermissions = Object.entries(role.permissions || {});
            return rolePermissions.length > 0 ? (
              rolePermissions.map(([category, permissions], catIndex) => (
                <TableRow key={`${roleIndex}-${catIndex}`}>
                  {catIndex === 0 && (
                    <>
                      <TableCell rowSpan={rolePermissions.length}>
                        {role.serial_no}
                      </TableCell>
                      <TableCell rowSpan={rolePermissions.length}>
                        {role.name}
                      </TableCell>
                    </>
                  )}
                  {catIndex === 0 && (
                    <TableCell rowSpan={rolePermissions.length}>
                      <Typography
                        variant='subtitle1'
                        className={`status-label ${
                          role.status === 0
                            ? 'active'
                            : role.status === 1
                            ? 'inactive'
                            : 'unknown'
                        }`}
                      >
                        <span
                          className={`status-value ${
                            role.status === 0
                              ? 'active'
                              : role.status === 1
                              ? 'inactive'
                              : 'unknown'
                          }`}
                        >
                          {role.status === 0
                            ? 'Active'
                            : role.status === 1
                            ? 'Inactive'
                            : 'Unknown'}
                        </span>
                      </Typography>
                    </TableCell>
                  )}
                  {catIndex === 0 && (
                    <TableCell rowSpan={rolePermissions.length}>
                      <Box className='button-list'>
                        {handleView && (
                          <Button
                            className='view-user-button'
                            variant='contained'
                            onClick={() => handleView(role)}
                            size='small'
                          >
                            View
                          </Button>
                        )}
                        {handleEdit && (
                          <Button
                            className='edit-user-button'
                            variant='contained'
                            color='primary'
                            onClick={() => handleEdit(role)}
                            size='small'
                          >
                            Edit
                          </Button>
                        )}
                        {handleDeleteClick && (
                          <Button
                            className='delete-user-button'
                            variant='contained'
                            color='error'
                            onClick={() => handleDeleteClick(role.id)}
                            size='small'
                          >
                            Delete
                          </Button>
                        )}
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow key={roleIndex}>
                <TableCell>{role.serial_no}</TableCell>
                <TableCell>{role.name}</TableCell>
                <TableCell colSpan={permissionsList.length + 3}>
                  No permissions assigned.
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      width='100%'
      py={5}
      mt={2}
      sx={{ backgroundColor: '#fff', borderRadius: '4px', minHeight: '300px' }}
    >
      <img src={nodata} alt='No Data' />
    </Box>
  );
};
export default ReusableRoleTable;
